import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { verify_mobile } from "../../../utils/Utils";

//Components
import Topo from "../../../components/Topo";
import TopoEmpresa from "../../../components/TopoEmpresa";
import Footer from "../../../components/Footer";
import DuvidasSection from "./DuvidasSection";

//Styles
import "../../../assets/css/guia_pages.css";

//Script
import "../../../assets/js/home.js";

import { connect } from "react-redux";
import { isAuthenticatedNode, getUserNode } from "../../../services/auth_node";

class Tickets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      load: true,
      loading: false,
      faixa_minimizada: false,
      id_duvida: this.props.match.params.id,
    };
  }

  componentWillMount() {
    document.title = `Dúvida #${this.state.id_duvida} - Grupo Voitto`;

    if (!isAuthenticatedNode()) {
      window.location.href = "/";
    }
  }

  render() {
    return (
      <div>
        {getUserNode().alunoEmpresa &&
        getUserNode().empresa &&
        getUserNode().empresa.id !== 10705 ? (
          <TopoEmpresa />
        ) : (
          <Topo id_duvida={this.state.id_duvida} />
        )}

        <div
          style={{ marginTop: !verify_mobile() ? 100 : 35 }}
          className="my_home"
        >
          <DuvidasSection
            id_duvida={this.state.id_duvida}
            isAdmin={JSON.parse(localStorage.getItem("_IS_ADM"))}
            history={this.props.history}
          />
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (store) => ({ view_by_tab: store.home.aba });
export default connect(mapStateToProps)(withRouter(Tickets));
